"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var ChevronLeft_1 = __importDefault(require("@mui/icons-material/ChevronLeft"));
var chatmessage_1 = __importDefault(require("../../components/Chatcomponents/chatmessage"));
var Chatting = function () {
    return (react_1.default.createElement(material_1.Container, { maxWidth: "md", sx: { p: 5 } },
        react_1.default.createElement(material_1.Button, { variant: "outlined", component: react_router_dom_1.Link, to: "/seller-home", sx: { marginLeft: "25px", marginTop: "-10px" }, color: "info", startIcon: react_1.default.createElement(ChevronLeft_1.default, null) }, "Home"),
        react_1.default.createElement(chatmessage_1.default, null)));
};
exports.default = Chatting;
